import axios from 'axios'
import store from './store/store'
import * as types from './store/types'
import router from './router'
import url from '@/common/common.js'
// axios 配置
axios.defaults.timeout = 10000
// axios.defaults.baseURL = 'http://backend.aiyihuo.com'
// axios.defaults.baseURL = 'http://rzbackend.aiyihuo.com'
axios.defaults.baseURL = url
// 默认地址

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (localStorage.token) {
      console.log('检查到没有token值')
      config.headers.Authorization = localStorage.token
      // config.headers.MemberAuth = store.state.token
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// http response 拦截器
axios.interceptors.response.use(
  response => {
    // return response
    // console.log(response)
    // 根据返回的ret值来做不同的处理（与后端约定）
    if (!response.data.ret) {
      console.log('#####http##!response.data.ret##', response)
      // console.log(router.currentRoute.path)
      // 清除token信息并跳转到登录页面
      store.commit(types.LOGOUT)
      // 只有在当前路由不是登录页面才跳转
      if (router.currentRoute.path !== '/log_on') {
        router.replace({ path: '/log_on', query: { redirect: router.currentRoute.fullPath } })
      } else {
        return response
      }
    } else {
      return response
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.LOGOUT)
          // 只有在当前路由不是登录页面才跳转
          router.currentRoute.path !== 'login' && router.replace({
            path: 'login',
            query: { redirect: router.currentRoute.path }
          })
      }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/http.js